import { generateCSV } from '@/utils/json-to-csv';
<template>
  <v-container fluid class="futures-operations">
    <h1 class="text-h5">Operações de Futuros</h1>

    <operations-base-filters :filters.sync="requestFilters" />

    <div class="text-right mb-4">
      <v-btn
        small
        rounded
        color="primary"
        class="mx-1"
        @click="() => fetchData()"
      >
        <v-icon small left>
          mdi-refresh
        </v-icon>

        Atualizar
      </v-btn>

      <v-btn
        small
        rounded
        color="primary"
        class="mx-1"
        :disabled="!isElevatedUser"
        @click="() => showCreationDialog()"
      >
        <v-icon small left>
          mdi-plus
        </v-icon>

        Novo
      </v-btn>

      <v-btn
        small
        rounded
        color="primary"
        class="mx-1"
        :disabled="!isElevatedUser"
        @click="() => showBatchDialog()"
      >
        <v-icon small left>
          mdi-plus-box-multiple
        </v-icon>

        Lote
      </v-btn>
    </div>

    <v-card class="mb-4" :loading="isFetchingData">
      <v-card-title>
        Overview

        <v-spacer />
        <v-btn
          class="mr-2 pr-3"
          small
          rounded
          color="primary"
          :disabled="!hasResults"
          @click="downloadCsv"
        >
          <v-icon small left> mdi-microsoft-excel </v-icon>
          Baixar
        </v-btn>
        <v-badge
          overlap
          color="info"
          :content="filterCount"
          :value="filterCount > 0"
        >
          <v-btn
            small
            rounded
            color="primary"
            class="mx-1"
            :disabled="!hasResults"
            @click="() => showFiltersDialog()"
          >
            <v-icon small left>
              mdi-filter
            </v-icon>

            Filtros
          </v-btn>
        </v-badge>
      </v-card-title>

      <futures-operations-overview :overview="resultsOverview" />
    </v-card>

    <v-card>
      <v-card-text>
        <assets-operations-table
          fixed-header
          dense
          :items="filteredResults"
          :isFiltered="filterCount > 0"
          :loading="isFetchingData"
          allow-bulk-delete
          must-sort
          sort-by="refDate"
          sort-desc
          hide-default-footer
          :items-per-page="-1"
          @click:delete="(ops) => showBulkDeletionDialog(ops)"
        >
          <template v-slot:details="{ item }">
            <v-card outlined>
              <futures-operations-details-table
                fixed-header
                dense
                :items="item.operationsArray"
                :readonly="!isElevatedUser"
                must-sort
                :sort-by.sync="detailsSortBy"
                :sort-desc.sync="detailsSortDesc"
                hide-default-footer
                :items-per-page="-1"
                @click:filter="() => showFiltersDialog()"
                @click:edit="(op) => showEditionDialog(op)"
                @click:delete="(op) => showDeletionDialog(op)"
              />
            </v-card>
          </template>
        </assets-operations-table>
        <v-row
          v-if="showLoadMore"
          class="my-2"
          align="center"
          justify="space-around"
        >
          <v-btn
            :loading="isFetchingData"
            @click="() => loadMore()"
            small
            color="primary"
          >
            Carregar mais
          </v-btn>
        </v-row>
      </v-card-text>
    </v-card>

    <v-dialog v-model="isFilterDialogOpen" persistent max-width="400">
      <v-card>
        <v-card-title>
          Filtrar itens
        </v-card-title>

        <futures-operations-filters
          :filters.sync="detailsFilters"
          :filter-options="filterOptions"
        />

        <v-card-actions class="justify-end">
          <v-btn color="primary" @click="() => hideFiltersDialog()">
            Confirmar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="isCreationDialogOpen" max-width="900">
      <v-card>
        <v-card-title class="justify-center white--text primary">
          Nova Operação de Futuros
        </v-card-title>

        <br />

        <v-card-text class="py-0">
          <futures-operations-form
            ref="creationForm"
            :loading="isSendingData"
            discard-btn-text="Cancelar"
            @click:discard="() => hideCreationDialog()"
            @submit="(fields) => createItem(fields)"
          />
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="isBatchDialogOpen" max-width="800">
        <batch-operations-dialog
        title="Operações de Futuros em Lote"
        @click:cancel="hideBatchDialog"
        :headers='batchFields'
        @click:submit="(fields) => createItem(fields)"
        />
      </v-dialog>

    <v-dialog v-model="isEditionDialogOpen" max-width="900">
      <v-card>
        <v-card-title class="justify-center white--text primary">
          Editar Operação de Futuros
        </v-card-title>

        <br />

        <v-card-text class="py-0">
          <futures-operations-form
            ref="editionForm"
            :loading="isSendingData"
            :initial-data="selectedItem || {}"
            discard-btn-text="Cancelar"
            @click:discard="() => hideEditionDialog()"
            @submit="(fields) => editItem(fields)"
          />
        </v-card-text>
      </v-card>
    </v-dialog>

    <contextual-dialog
      v-model="isDeletionDialogOpen"
      icon="mdi-delete"
      :icon-color="isSendingData ? 'grey' : 'error'"
      :loading="isSendingData"
      title="Deletar operação?"
      message="Deseja realmente deletar a operação?"
    >
      <v-card-actions class="justify-center">
        <v-btn
          color="primary"
          :disabled="isSendingData"
          @click="() => deleteItem()"
        >
          Deletar
        </v-btn>
      </v-card-actions>
    </contextual-dialog>

    <contextual-dialog
      v-model="isBulkDeletionDialogOpen"
      icon="mdi-delete"
      :icon-color="isSendingData ? 'grey' : 'error'"
      :loading="isSendingData"
      title="Deletar Operações"
      message="Deseja realmente deletar TODAS essas operações do fundo na data?"
    >
      <v-card-actions class="justify-center">
        <v-btn
          color="error"
          :disabled="isSendingData"
          @click="() => bulkDeleteItems()"
        >
          Deletar tudo
        </v-btn>
      </v-card-actions>
    </contextual-dialog>
  </v-container>
</template>

<script>
import {
  flatMap,
  debounce,
  isNil,
  round,
} from 'lodash';
import moment from 'moment-loyall';
import api from '@/services/api';
import { generateCSV } from '@/utils/json-to-csv';

import ContextualDialog from '@/components/global/ContextualDialog.vue';

import { parseRequestFilters, getApiErrors } from './utils/common-utils';

import {
  filterFuturesResults,
  getFuturesFilterOptions,
  getFuturesOverview,
} from './utils/futures-operations-utils';

import AssetsOperationsTable from './AssetsOperationsTable.vue';
import OperationsBaseFilters from './OperationsBaseFilters.vue';
import FuturesOperationsFilters from './FuturesOperationsFilters.vue';
import FuturesOperationsOverview from './FuturesOperationsOverview.vue';
import FuturesOperationsDetailsTable from './FuturesOperationsDetailsTable.vue';
import FuturesOperationsForm from './FuturesOperationsForm.vue';
import BatchOperationsDialog from './components/BatchOperationsDialog.vue';

export default {
  name: 'FuturesOperations',

  components: {
    ContextualDialog,
    AssetsOperationsTable,
    OperationsBaseFilters,
    FuturesOperationsFilters,
    FuturesOperationsOverview,
    FuturesOperationsDetailsTable,
    FuturesOperationsForm,
    BatchOperationsDialog,
  },

  data: () => ({
    isFetchingData: false,
    results: [],
    total: 0,

    requestFilters: {
      houseFundIds: [],
      initialDate: moment().businessSubtract(5, 'days', 'brasil').format('YYYY-MM-DD'),
      finalDate: null,
    },

    isFilterDialogOpen: false,
    detailsFilters: {
      ticker: [],
      book: [],
      operation: [],
    },

    detailsSortBy: 'ticker',
    detailsSortDesc: false,

    selectedItem: null,
    isSendingData: false,

    isCreationDialogOpen: false,
    isEditionDialogOpen: false,
    isDeletionDialogOpen: false,
    isBulkDeletionDialogOpen: false,

    isBatchDialogOpen: false,
    batchFields: [
      'houseFundId',
      'refDate',
      'settlementDate',
      'operation',
      'ticker',
      'book',
      'quantity',
      'unitaryPrice',
      'adjustmentValue',
      'value',
      'brokerId',
      'carryingBrokerage',
      'registryFees',
      'notaryFees',
      'executionBrokerId',
      'executionBrokerage',
      'brokerage',
    ],

    filters: {
      books: [],
      tickers: [],
    },
  }),

  computed: {
    isElevatedUser: (vm) => ['admin', 'backoffice'].includes(vm.$store.state.user?.acl),

    hasResults: (vm) => vm.results.length > 0,
    flatResults: (vm) => flatMap(vm.results, 'operationsArray'),

    filterCount: (vm) => Object.values(vm.detailsFilters).filter((val) => (Array.isArray(val) ? val.length > 0 : !!val)).length,
    filterOptions: (vm) => ({
      ...getFuturesFilterOptions(vm.flatResults),
      book: vm.filters.books,
      ticker: vm.filters.tickers,
    }),
    filteredResults: (vm) => filterFuturesResults(vm.results, vm.detailsFilters),
    flatFilteredResults: (vm) => flatMap(vm.filteredResults, 'operationsArray'),

    resultsOverview: (vm) => getFuturesOverview(vm.flatFilteredResults),
    showLoadMore: (vm) => vm.total > vm.filteredResults.length,
  },

  watch: {
    requestFilters: {
      deep: true,
      immediate: true,
      handler() {
        this.fetchData();
      },
    },

    isDeletionDialogOpen(newState) {
      if (!newState) {
        this.selectedItem = null;
      }
    },

    isBulkDeletionDialogOpen(newState) {
      if (!newState) {
        this.selectedItem = null;
      }
    },
  },

  created() {
    this.$store.dispatch('houseFunds/fetchList');
  },

  methods: {
    downloadCsv() {
      const data = this.filteredResults.map(({
        houseFundId, name, refDate, operationsArray,
      }) => operationsArray.map((operation) => {
        const cleanOperation = operation;

        delete cleanOperation._id;

        return {
          houseFundId,
          name,
          refDate,
          ...cleanOperation,
        };
      })).reduce((pre, cur) => pre.concat(cur));

      generateCSV(data);
    },

    showFiltersDialog() {
      this.isFilterDialogOpen = true;
    },

    hideFiltersDialog() {
      this.isFilterDialogOpen = false;
      this.fetchData();
    },

    showEditionDialog(operation) {
      const decimalToPercentage = (val) => (round(val * 100, 8));
      const operationData = { ...operation };

      if (operationData.refDate) {
        operationData.refDate = operationData.refDate.substring(0, 10);
      }

      if (operationData.settlementDate) {
        operationData.settlementDate = operationData.settlementDate.substring(0, 10);
      }

      if (operationData.rate) {
        operationData.rate = decimalToPercentage(operationData.rate);
      }

      this.selectedItem = operationData;

      this.isEditionDialogOpen = true;

      if (this.$refs.editionForm) {
        this.$nextTick(() => this.$refs.editionForm.discardChanges());
      }
    },

    hideEditionDialog() {
      this.isEditionDialogOpen = false;
      this.selectedItem = null;

      if (this.$refs.editionForm) {
        this.$nextTick(() => this.$refs.editionForm.discardChanges());
      }
    },

    showDeletionDialog(operation) {
      this.selectedItem = operation;
      this.isDeletionDialogOpen = true;
    },

    hideDeletionDialog() {
      this.isDeletionDialogOpen = false;
    },

    showBulkDeletionDialog(operations) {
      this.selectedItem = operations;
      this.isBulkDeletionDialogOpen = true;
    },

    hideBulkDeletionDialog() {
      this.isBulkDeletionDialogOpen = false;
    },

    showCreationDialog() {
      this.isCreationDialogOpen = true;
    },

    hideCreationDialog() {
      this.isCreationDialogOpen = false;

      this.$nextTick(() => this.$refs.creationForm?.discardChanges());
    },

    showBatchDialog() {
      this.isBatchDialogOpen = true;
    },

    hideBatchDialog() {
      this.isBatchDialogOpen = false;
    },

    async loadMore() {
      this.isFetchingData = true;

      try {
        const { data: { operationsList, total, ...filters } = {} } = await api.operations.futures.getFuturesOperations({
          params: {
            ...parseRequestFilters(this.requestFilters),
            ...this.detailsFilters,
            offset: this.filteredResults.length,
          },
        });
        this.total = total;
        this.filters = filters;
        this.results = [...this.results, ...operationsList] ?? [];
      } catch (error) {
        this.$store.dispatch('alert/showAlert', {
          title: 'Algo de errado aconteceu!',
          message: 'Não foi possível completar a requisição',
          errorList: getApiErrors(error),
        });
      } finally {
        this.isFetchingData = false;
      }
    },

    fetchData: debounce(async function debouncedFetchData() {
      this.isFetchingData = true;

      try {
        const { data: { operationsList, total, ...filters } = {} } = await api.operations.futures.getFuturesOperations({
          params: { ...parseRequestFilters(this.requestFilters), ...this.detailsFilters },
        });
        this.total = total;
        this.filters = filters;
        this.results = operationsList ?? [];
      } catch (error) {
        this.$store.dispatch('alert/showAlert', {
          title: 'Algo de errado aconteceu!',
          message: 'Não foi possível completar a requisição',
          errorList: getApiErrors(error),
        });
      } finally {
        this.isFetchingData = false;
      }
    }, 200),

    async createItem(rawData) {
      this.isSendingData = true;

      try {
        const newData = {};

        // Remove empty values
        Object.entries(rawData).forEach(([key, value]) => {
          if (!isNil(value) && String(value).length > 0) {
            newData[key] = value;
          }
        });

        await api.operations.futures.createFuturesOperation({ operations: Array.isArray(rawData) ? rawData : [newData] });

        this.$store.dispatch('alert/showAlert', {
          icon: 'mdi-check-bold',
          iconColor: 'success',
          title: 'Operação adicionada com sucesso!',
          message: 'Os dados da operação foram inseridos corretamente.',
        });

        this.fetchData();
      } catch (error) {
        this.$store.dispatch('alert/showAlert', {
          title: 'Algo de errado aconteceu!',
          message: 'Não foi possível inserir a operação',
          errorList: getApiErrors(error),
        });
      } finally {
        this.isSendingData = false;
      }
    },

    async editItem(newData) {
      this.isSendingData = true;

      try {
        await api.operations.futures.updateFuturesOperation(this.selectedItem._id, newData);

        this.$store.dispatch('alert/showAlert', {
          icon: 'mdi-check-bold',
          iconColor: 'success',
          title: 'Operação atualizada com sucesso!',
          message: 'Os dados da operação foram atualizados corretamente.',
        });

        this.fetchData();
        this.hideEditionDialog();
      } catch (error) {
        this.$store.dispatch('alert/showAlert', {
          title: 'Algo de errado aconteceu!',
          message: 'Não foi possível editar a operação',
          errorList: getApiErrors(error),
        });
      } finally {
        this.isSendingData = false;
      }
    },

    async deleteItem() {
      this.isSendingData = true;

      try {
        await api.operations.futures.deleteFuturesOperation(this.selectedItem._id);

        this.$store.dispatch('alert/showAlert', {
          icon: 'mdi-check-bold',
          iconColor: 'success',
          title: 'Operação excluída com sucesso!',
          message: 'Os dados da operação foram removidos corretamente.',
        });

        this.fetchData();
      } catch (error) {
        this.$store.dispatch('alert/showAlert', {
          title: 'Algo de errado aconteceu!',
          message: 'Não foi possível deletar a operação',
          errorList: getApiErrors(error),
        });
      } finally {
        this.hideDeletionDialog();
        this.isSendingData = false;
      }
    },

    async bulkDeleteItems() {
      this.isSendingData = true;

      try {
        await api.operations.futures.bulkDeleteFuturesOperations(this.selectedItem._id);

        this.$store.dispatch('alert/showAlert', {
          icon: 'mdi-check-bold',
          iconColor: 'success',
          title: 'Operações excluídas com sucesso!',
          message: 'Os dados das operações foram removidos corretamente.',
        });

        this.fetchData();
      } catch (error) {
        this.$store.dispatch('alert/showAlert', {
          title: 'Algo de errado aconteceu!',
          message: 'Não foi possível deletar as operações',
          errorList: getApiErrors(error),
        });
      } finally {
        this.hideBulkDeletionDialog();
        this.isSendingData = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep {
  th {
    white-space: nowrap;
  }
}
</style>
